<template>
  <Suspense :loading="isLoading">
    <div class="user-block-simple">
      <div v-if="isAuthenticated && user" class="user-authenticated">
        <div class="user-name">{{ displayName }}</div>
        <a href="#" @click.prevent="handleLogout" class="user-action">Sign Out</a>
      </div>
      <div v-else class="user-guest">
        <a href="#" @click.prevent="handleLogin" class="user-action-primary">Sign In</a>
      </div>
    </div>
  </Suspense>
</template>

<script>
import { computed, onMounted } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import Authentication from "../../util/Authentication";
import Suspense from "../utility/Suspense.vue";

export default {
  name: "UserBlock",
  components: { Suspense },
  
  setup() {
    const { isAuthenticated, isLoading, user, loginWithRedirect, logout } = useAuth0();

    // Set Auth0 instance for Authentication utility
    onMounted(() => {
      Authentication.setAuth0Instance({ isAuthenticated, isLoading, user, loginWithRedirect, logout });
    });

    const displayName = computed(() => {
      if (!user.value) return '';
      return user.value.given_name || user.value.name || user.value.nickname || user.value.email;
    });

    const handleLogin = () => {
      loginWithRedirect();
    };

    const handleLogout = () => {
      Authentication.clearSession();
      logout({
        logoutParams: {
          returnTo: window.location.origin
        }
      });
    };

    return {
      isAuthenticated,
      isLoading,
      user,
      displayName,
      handleLogin,
      handleLogout,
    };
  },
};
</script>
